
    import './styles.scoped.css';
    export default {
  "tutorial-list": "awsui_tutorial-list_1u70p_194f2_9",
  "tutorial-title": "awsui_tutorial-title_1u70p_194f2_45",
  "task": "awsui_task_1u70p_194f2_52",
  "task-title": "awsui_task-title_1u70p_194f2_60",
  "task-title--status": "awsui_task-title--status_1u70p_194f2_68",
  "current-task": "awsui_current-task_1u70p_194f2_72",
  "successful-task": "awsui_successful-task_1u70p_194f2_76",
  "congratulation-message": "awsui_congratulation-message_1u70p_194f2_80",
  "congratulation-message--status": "awsui_congratulation-message--status_1u70p_194f2_88",
  "plaintext-congratulation-description": "awsui_plaintext-congratulation-description_1u70p_194f2_93",
  "divider": "awsui_divider_1u70p_194f2_97",
  "step-list": "awsui_step-list_1u70p_194f2_101",
  "step": "awsui_step_1u70p_194f2_101",
  "expandable-section-wrapper": "awsui_expandable-section-wrapper_1u70p_194f2_112",
  "expandable-section-header": "awsui_expandable-section-header_1u70p_194f2_116",
  "step-title": "awsui_step-title_1u70p_194f2_121",
  "feedback-link": "awsui_feedback-link_1u70p_194f2_122",
  "dismiss-button": "awsui_dismiss-button_1u70p_194f2_123",
  "completion-screen-title": "awsui_completion-screen-title_1u70p_194f2_124",
  "completion-screen-description": "awsui_completion-screen-description_1u70p_194f2_125"
};
  